module.exports = __webpack_public_path__ + "static/media/OwnDevice.db543d39.svg";